import dayjs from "dayjs";
import { Form, Select, DatePicker, Empty } from "antd";
const { RangePicker } = DatePicker;

const dateValues = {
	Today: dayjs(new Date()),
	SOM: dayjs().startOf("month"),
	EOM: dayjs().endOf("month"),
};

const RenderFilterFields = ({ filtersData }) => {
	return filtersData.map((filter) => {
		switch (filter.filter_type) {
			case "code_name_spinner":
				return (
					<Form.Item
						key={filter.filter_code}
						label={filter.filter_title}
						name={filter.filter_code}
					>
						<Select
							allowClear
							showSearch
							mode={filter.is_single_select ? undefined : "multiple"}
							options={filter.filter_values.map((val) => ({
								label: val.value,
								value: val.code,
							}))}
							placeholder={`Select ${filter.filter_title}`}
							notFoundContent={
								filter.filter_values?.length ? null : (
									<Empty description="No Options Available" />
								)
							}
							filterOption={(input, option) =>
								option.label.toLowerCase().includes(input.toLowerCase())
							}
						/>
					</Form.Item>
				);

			case "multi_date_picker":
				return (
					<Form.Item
						key={filter.filter_code}
						name={filter.filter_code}
						label={filter.filter_title}
					>
						<RangePicker
							format="DD-MM-YYYY"
							style={{ width: "100%" }}
							defaultValue={[
								dateValues[filter.default_filter_value[0]],
								dateValues[filter.default_filter_value[1]],
							]}
						/>
					</Form.Item>
				);

			case "single_date_picker":
				return (
					<Form.Item
						key={filter.filter_code}
						name={filter.filter_code}
						label={filter.filter_title}
					>
						<DatePicker
							format="YYYY-MM-DD"
							style={{ width: "100%" }}
							defaultValue={dateValues[filter.default_filter_value]}
						/>
					</Form.Item>
				);

			default:
				return null;
		}
	});
};

export default RenderFilterFields;
